import { Actions } from 'ha/modules/RealtimeMessaging/constants';

interface Action {
  type: Actions;
}

export default (action: Action) => action.type === Actions.RECEIVE_MESSAGE;
